import { createFileRoute, redirect } from '@tanstack/react-router'
import { EmailTemplatesPage } from '@/pages/EmailTemplates/EmailTemplatesPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/email-templates')({
  component: EmailTemplatesPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/email-templates')) {
      throw redirect({ to: '/' })
    }
  },
})
